<template>
  <modal :open="internalOpen" :full-width="true" :full-height="true">
    <template #header>
      <modal-header variant="cross" @cancel="closeModal()">
        <h1>{{ $t('pages.images.verifications.editVerificationModal.title') }}</h1>
      </modal-header>
    </template>

    <div class="pt-8 h-full">
      <div class="flex flex-col justify-center w-full h-full">
        <div class="grow">
          <Verification-comp v-model:verification="internalVerification" v-model:loading-verified="loadingVerified" @verified="closeModal()" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import {
  ref,
} from 'vue';
import { useVModel } from '@vueuse/core';
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import VerificationComp from '@pages/images/verifications/Verification.vue';
import type { Verification } from '@/entities/Entities';

interface Props {
  open: boolean;
  verification: Verification;
}

const loadingVerified = ref(false);

const emit = defineEmits(['update:open', 'update:verification', 'close']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);
const internalVerification = useVModel(props, 'verification', emit);

function closeModal() {
  internalOpen.value = false;
  loadingVerified.value = false;
  emit('close');
}
</script>

<style lang="scss" scoped></style>
